import React from "react";

export default function LoadingScreen() {
  return (
    // loading screen with framer motion and tailwindcss responsive for mobile and desktop

    <div className="flex h-max w-max flex-col items-center justify-center bg-gray-900">
      <div className="flex flex-col items-center justify-center">
        <div className="flex flex-row items-center justify-center">
          <div className="mr-1 h-3 w-3 animate-pulse rounded-full bg-gray-400"></div>
          <div className="mr-1 h-3 w-3 animate-pulse rounded-full bg-gray-400"></div>
          <div className="h-3 w-3 animate-pulse rounded-full bg-gray-400"></div>
        </div>
        <div className="flex flex-row items-center justify-center">
          <div className="mr-1 h-3 w-3 animate-pulse rounded-full bg-gray-400"></div>
          <div className="mr-1 h-3 w-3 animate-pulse rounded-full bg-gray-400"></div>
          <div className="h-3 w-3 animate-pulse rounded-full bg-gray-400"></div>
        </div>
      </div>
    </div>
  );
}
